var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesProgramms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.193 33.399h80.614c5.607 0 10.193 4.585 10.193 10.193v50.235c0 5.608-4.586 10.193-10.193 10.193H12.193C6.586 104.02 2 99.435 2 93.827V43.592c0-5.605 4.589-10.193 10.193-10.193Z",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.194 42.932h53.623c2.727 0 4.959 2.24 4.959 4.959v41.638c0 2.721-2.24 4.959-4.96 4.959H17.195c-2.722 0-4.962-2.232-4.962-4.96V47.892c.003-2.728 2.234-4.96 4.962-4.96ZM88.894 52.808a4.531 4.531 0 1 1-4.532 4.532c0-2.5 2.029-4.532 4.532-4.532ZM88.894 69.119a4.531 4.531 0 1 1 0 9.064 4.533 4.533 0 0 1 0-9.064ZM88.894 85.427a4.531 4.531 0 1 1 0 9.064 4.533 4.533 0 0 1 0-9.064ZM69.852 4.039 56.746 23.696M48.764 23.044l-9.801-12.687M39.01 7.25a2.549 2.549 0 1 1 0 5.098 2.549 2.549 0 0 1 0-5.098ZM69.796 1.802a2.549 2.549 0 1 1 0 5.097 2.549 2.549 0 0 1 0-5.097ZM38.739 32.801c2.461-5.449 7.704-9.213 13.771-9.213 6.238 0 11.603 3.976 13.972 9.676",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesProgramms);
export default __webpack_public_path__ + "static/media/features-programms.415506f189dee04023417da1dcf0403d.svg";
export { ForwardRef as ReactComponent };